import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { getAllowedFileTypes, validateFiles } from 'Services/File/FileService';
import { uploadFilesForEntityId } from 'Store/Modules/Files/Actions';
import { StoreState } from 'Store/Reducers';
import styles from './Dropzone.module.sass';

const Dropzone = ({
    id, onDragStart,
    ...props
}: DropzoneProps) => {
    const [state, setState] = useState({
        isDragging: false
    });
    
    const [counter, setCounter] = useState(0);

    const dragCounter = React.useRef(0);
  
    const handleDrag = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
    }, []);

    const handleDragIn = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        dragCounter.current++;
        if (getAllowedFileTypes.includes(event.dataTransfer.items?.[0].type) &&
            event.dataTransfer.items &&
            event.dataTransfer.items.length > 0
        ) {
            setState({ ...state, isDragging: true });
            onDragStart();
        }
    }, []);

    const handleDragOut = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        dragCounter.current--;
        if (dragCounter.current > 0) return;
        setState({ ...state, isDragging: false });
    }, []);

    const processFiles = (files) => {
        const isValid = validateFiles(files);
        if (!isValid) return;

        const formData = new FormData();
        for (const file of files) {
            formData.append("files[]", file);
        }

        props.uploadFilesForEntityId(id, formData);
    }

    const handleDrop = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setState({ ...state, isDragging: false });
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            dragCounter.current = 0;
            
            const files = event.dataTransfer.files;
            processFiles(files);

            event.dataTransfer.clearData();
            
            setTimeout(() => {
                setState({ ...state, isDragging: false });
            }, 600);
        }
    }, []);
  
    React.useEffect(() => {
        window.addEventListener("dragenter", handleDragIn);
        window.addEventListener("dragleave", handleDragOut);
        window.addEventListener("dragover", handleDrag);
        window.addEventListener("drop", handleDrop);
        return function cleanUp() {
            window.removeEventListener("dragenter", handleDragIn);
            window.removeEventListener("dragleave", handleDragOut);
            window.removeEventListener("dragover", handleDrag);
            window.removeEventListener("drop", handleDrop);
        };
    });

    return <div className={`${styles['dropzone']} ${state.isDragging ? styles['dropzone--active'] : ''}`}>
        
    </div>;
};

interface Props {
    id: any
    onDragStart: any
}

const mapState = (state: StoreState, props: Props) => ({

});

const mapDispatch = {
    uploadFilesForEntityId
};

type DropzoneProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Dropzone);